export default {"src":"/_next/static/media/special-products-icon.b9354796.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};